/**
 * Maps each tool slug to its interactive widget. Kept separate from the
 * catalog (`lib/tools.ts`) so the catalog stays pure data (and can be imported
 * in non-React contexts) while the widgets live here.
 */
import type { ComponentType } from 'react';
import { CharacterCounter } from './CharacterCounter';
import { BestTimeToPost } from './BestTimeToPost';
import { EngagementCalculator } from './EngagementCalculator';
import { BioGenerator } from './BioGenerator';
import { HashtagGenerator } from './HashtagGenerator';
import { CaptionGenerator } from './CaptionGenerator';
import { IdeaGenerator } from './IdeaGenerator';

export const TOOL_WIDGETS: Record<string, ComponentType> = {
  'contador-de-caracteres': CharacterCounter,
  'mejor-hora-para-publicar': BestTimeToPost,
  'calculadora-de-engagement': EngagementCalculator,
  'generador-de-bio': BioGenerator,
  'generador-de-hashtags': HashtagGenerator,
  'generador-de-captions': CaptionGenerator,
  'generador-de-ideas': IdeaGenerator,
};
